 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis
//  let service_data=getEnv(tag).service_data

export default {
  /**
   * 项目是否在国匠云授权
   */
  authorityAbout: `${new_service_basis}/about/abou`,
  /**
   *项目是否校验注册码和授权码
   */
  authorityIsGrant: `${new_service_basis}/access/isGrant`,
  /**
   *校验注册码和授权码
   */
  authorityRegister: `${new_service_basis}/online/register`,

};
